import { FormSectionGroup } from '@vwfs-bronson/bronson-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AddressFormNew } from '../../../../../../components/AddressFormNew';
import { AddressFormModel_MX } from '../../../../../../components/AddressFormNew/mixed/formModel';
import { BankDetailsNew } from '../../../../../../components/BankDetailsNew';
import { CompanyDetailsForm_OB_FP } from '../../../../../../components/CompanyDetailsFormNew/business/otherBusiness/financialProduct/CompanyDetailsForm_OB_FP';
import { CustomerDetailsFormNew } from '../../../../../../components/CustomerDetailsFormNew';
import { FinancialDetailsForm } from '../../../../../../components/FinancialDetailsForm/FinancialDetailsForm';
import { LinkedRelationshipsForm_OB_FP } from '../../../../../../components/LinkedRelationshipsNew/business/otherBusiness/financialProduct/LinkedRelationships_OB_OL';
import { PreviousAddressFormNew } from '../../../../../../components/PreviousAddressFormNew';
import { TradingDetailsServicePlanFormNew } from '../../../../../../components/TradingDetailsServicePlanFormNew';
import { isAtLeast3YearsApart } from '../../../../../../services/common/miscUtils';
import { journeyDataSelectors } from '../../../../../../services/redux/features/journeyData.slice';
import { useFormSectionHelpers } from '../../../../../utils';

const getCustomerFormsToRender = (showPreviousAddress: boolean, showBankDetails: boolean) => {
  return [
    'tradingDetails',
    'companyDetails',
    'customerDetails',
    'customerAddress',
    ...(showPreviousAddress ? (['customerPreviousAddress'] as const) : []),
    'customerfinancialDetails',
    'linkedRelationships',
    ...(showBankDetails ? (['bankDetails'] as const) : []),
  ] as const;
};

type FormId = ReturnType<typeof getCustomerFormsToRender>[number];

export const CustomerData_FP_SoleTrader = () => {
  const [forms, setForms] = useState<ReadonlyArray<FormId>>(() => getCustomerFormsToRender(false, false));
  const [showPreviousAddress, setShowPreviousAddress] = useState(false);

  const isUpfrontPayment = useSelector(journeyDataSelectors.isUpfrontPayment);

  useEffect(() => {
    setForms([...getCustomerFormsToRender(showPreviousAddress, !isUpfrontPayment)]);
  }, [isUpfrontPayment, showPreviousAddress]);

  const getFormHelpers = useFormSectionHelpers(forms);

  const onCustomerAddressChange = (values: AddressFormModel_MX) => {
    const { timeAtAddressFrom, timeAtAddressTo } = values;
    if (!timeAtAddressFrom || !timeAtAddressTo) return;

    setShowPreviousAddress(!isAtLeast3YearsApart(timeAtAddressFrom, timeAtAddressTo));
  };

  useEffect(() => {
    setForms([...getCustomerFormsToRender(showPreviousAddress, !isUpfrontPayment)]);
  }, [isUpfrontPayment, showPreviousAddress]);

  return (
    <FormSectionGroup>
      <TradingDetailsServicePlanFormNew.FP formHelpers={getFormHelpers('tradingDetails')} />

      <CompanyDetailsForm_OB_FP formHelpers={getFormHelpers('companyDetails')} />

      <CustomerDetailsFormNew.FP formHelpers={getFormHelpers('customerDetails')} />

      <AddressFormNew.FP formHelpers={getFormHelpers('customerAddress')} onValuesChange={onCustomerAddressChange} />

      {showPreviousAddress && <PreviousAddressFormNew.PL formHelpers={getFormHelpers('customerPreviousAddress')} />}

      {/* TODO: form below needs to be rewritten */}
      <FinancialDetailsForm isMainApplicant />

      <LinkedRelationshipsForm_OB_FP
        formHelpers={getFormHelpers('linkedRelationships')}
        titleTranslationKey="linkedRelationshipsForm:title:soleTrader"
      />

      <BankDetailsNew.FP
        formHelpers={getFormHelpers('bankDetails')}
        titleTranslationKey="bankDetailsForm:title:business"
      />
    </FormSectionGroup>
  );
};
